import { REDUCER } from '../reducers/reducersConst';

export let setCustomConfirmModalOpened = (opened = false, customMessage = undefined, onSubmit = undefined) => {
  return {
    type: REDUCER.REVEAL.SET_CUSTOM_CONFIRM_MODAL_OPENED,
    customConfirmModalObject: {
      opened,
      customMessage,
      onSubmit
    }
  };
};

export let setLinkedBookModalOpened = (opened = false, customMessage = undefined) => {
  return {
    type: REDUCER.REVEAL.SET_LINKED_BOOK_MODAL_OPENED,
    linkedBookModalObject: {
      opened,
      customMessage
    }
  };
};

export let openPinCodesReveal = (student = undefined) => {
  return {
    type: REDUCER.REVEAL.OPEN_PINS_REVEAL,
    student
  };
};

export let openDisableCommentReveal = (open = true, task = undefined) => {
  return {
    type: REDUCER.REVEAL.OPEN_DISABLE_COMMENT_REVEAL,
    task,
    open
  };
};

export let openDisableEvaluationsReveal = (open = true, task = undefined) => {
  return {
    type: REDUCER.REVEAL.OPEN_DISABLE_EVALUATIONS_REVEAL,
    task,
    open
  };
};

export let openStudentsWithFilesReveal = (open = true, students = undefined) => {
  return {
    type: REDUCER.REVEAL.OPEN_STUDENTS_WITH_FILES_REVEAL,
    students,
    open
  };
};

export let studentsWithFilesConfirmation = (confirmation = true) => {
  return {
    type: REDUCER.REVEAL.STUDENTS_WITH_FILES_CONFIRMATION,
    confirmation
  };
};

export let disableEvaluationsReveal = (disable = true) => {
  return {
    type: REDUCER.REVEAL.DISABLE_EVALUATIONS_REVEAL,
    disable
  };
};

export let closePinCodesReveal = () => {
  return {
    type: REDUCER.REVEAL.CLOSE_PINS_REVEAL
  };
};

export let setOpenReveal = openedReveal => {
  return {
    type: REDUCER.REVEAL.SET_OPENED_REVEAL,
    openedReveal
  };
};

export let openStudentsWithoutAssignmentInLessons = (open = true, students = undefined, sendObject = undefined) => {
  return {
    type: REDUCER.REVEAL.OPEN_STUDENTS_WITHOUT_ASSIGNMENT_IN_LESSONS,
    students,
    open,
    sendObject
  };
};

export let openTaskWithoutStudentsOfThisGroup = (open = true, students = undefined, sendObject = undefined) => {
  return {
    type: REDUCER.REVEAL.OPEN_TASK_WITHOUT_STUDENTS_OF_THIS_GROUP,
    open
  };
};
